import { Injectable, OnDestroy } from '@angular/core';
import { NeoTopNavbarAppSwitcherOptionConfig } from '@neogov/top-navbar-definition';
import { catchError, map, Observable, Subscription } from 'rxjs';
import { ConfigService } from '@app/configuration/config.service';
import { HttpClientService } from '@api/api-services/http-client.service';
import { HttpHeaders } from '@angular/common/http';
import { UrlSecurityService } from './url-security.service';
import { RouteHelperService } from './route-helper.service';
import { NavNotificationsService } from '@app/api/api-services/nav-notifications.service';
import { LayoutService } from './layout.service';
import { TokenStorageService } from './token-storage.service';
@Injectable({
  providedIn: 'root'
})
export class TopNavBarService implements OnDestroy {
  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private readonly http: HttpClientService,
    private readonly routeHelper: RouteHelperService,
    private readonly notificationsService: NavNotificationsService,
    private readonly layoutService: LayoutService,
    private readonly tokenStorageService: TokenStorageService,
    private readonly configService: ConfigService,
    private readonly urlSecurityService: UrlSecurityService
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public getAppSwitcherOptions(token: string): Observable<NeoTopNavbarAppSwitcherOptionConfig[]> {
    const callingApp = 'PFTO';
    const endpoint = `${
      this.configService.getConfig().authSettings.authServerUrl
    }/accounts/products?callingApp=${callingApp}`;

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };

    return this.http.get<any>(endpoint, httpOptions, true).pipe(
      map((result) => {
        return this.convertToAppSwitcherOptions(result);
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  public logout(): void {
    this.routeHelper.logout();
    this.notificationsService.closeNotifications();
    this.setSidebarOpenCloseState();
  }

  public myProfile(userId: string): void {
    this.routeHelper.reload(this.routeHelper.getUserProfileUrl(userId));
    this.notificationsService.closeNotifications();
    this.setSidebarOpenCloseState();
  }

  public setSidebarOpenCloseState(): void {
    if (!this.tokenStorageService.userInfo?.CurrentSite.PlatformTopNavEnabled) {
      if (window.innerWidth < 768) {
        this.layoutService.closeSidebar();
      } else {
        this.layoutService.openSidebar();
      }
    }
  }

  private convertToAppSwitcherOptions(result: any): any {
    const appSwitchOptions: NeoTopNavbarAppSwitcherOptionConfig[] =
      result?.options.map((option) => {
        return {
          id: option.id,
          clickable: {
            type: 'anchor',
            anchorHref: option.productUrl,
            anchorTarget: '_blank',
            onClick: (e: Event) => {
              e.preventDefault();
              this.urlSecurityService.safeOpenExternal(option.productUrl);
              return {
                preventOverlayClose: false
              };
            }
          },
          categories: option.categories.map((category) => {
            return this.convertCategory(category);
          })
        };
      }) || [];

    return appSwitchOptions;
  }

  private convertCategory(category: any): any {
    return {
      name: category.name,
      products: category.products.map((product) => {
        return {
          name: product.name,
          clickable: {
            type: 'button',
            onClick: () => {
              this.urlSecurityService.safeOpenExternal(product.productUrl);
              return {
                preventOverlayClose: false
              };
            }
          }
        };
      })
    };
  }
}
